module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAATCAYAAAB2pebxAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CGwkPKVVXmYMAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAAZElEQVQ4T2NgYGD8TzkGEqExURi4tLoGA0+aNRUD4zQEmwEwTLIhEAUQPFINQdZECA8BQ2CYojAZFoaAAKpBxBqCZAAMIAyCacCG8RgAA/gNIsIAGMBuEAkGwAAkHLBjdMDAAACI+xqkRn2e4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/icons/defense-icon.png
// module id = 488
// module chunks = 0